// A select filter with `props.includeNoneOption` offers an extra "None" entry
// that matches rows whose column is empty. The backend recognizes the literal
// `Null` id inside the id list (e.g. `entity_id=Null,5`), so the option is a
// synthetic option object rather than anything the server returns.
export const NONE_OPTION_ID = "Null";

export const NONE_OPTION = { id: NONE_OPTION_ID, name: "None" };

// Other option lists on these same tables spell the sentinel "None" (the case
// investigator filter, for one), and the backend accepts either spelling, so a
// copied or hand-edited URL can carry either in any casing. Reading treats them
// alike; writing always emits the canonical `Null`.
const SENTINEL_IDS = new Set(["null", "none"]);

export const isNoneOptionId = id =>
  typeof id === "string" && SENTINEL_IDS.has(id.trim().toLowerCase());
